import { render, staticRenderFns } from "./jinhe.vue?vue&type=template&id=33e39387&scoped=true&"
import script from "./jinhe.vue?vue&type=script&lang=js&"
export * from "./jinhe.vue?vue&type=script&lang=js&"
import style0 from "./jinhe.vue?vue&type=style&index=0&id=33e39387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e39387",
  null
  
)

export default component.exports